/*
    Author: draplater
    Create Time: 17-8-7
    Project: verbnet2017
*/

/**
 * Created by draplater on 17-7-18.
 */


export interface Span {
    text: string,
    role?: string
}

export class Sentence extends Array<Span> {
    constructor(...seq) {
        super(...seq);
        Object.setPrototypeOf(this, Sentence.prototype);
    }

    static parseSentence(sentence: string, onErr?: (err: string) => void): Sentence {
        const spans: Sentence = new Sentence();
        let pos = 0;
        while (pos < sentence.length) {
            if (sentence[pos] === "[") {
                const right_pos = sentence.indexOf("]", pos);
                if (right_pos < 0) {
                    if (onErr === undefined) {
                        if (typeof(window) !== "undefined") {
                            window.alert(`Wrong sentence: ${sentence}`);
                        } else {
                            console.log(`Wrong sentence: ${sentence}`);
                        }
                    } else {
                        onErr(sentence);
                    }
                    return new Sentence({"text": sentence, role: undefined});
                }
                const [text, role] = sentence.substring(pos + 1, right_pos).split("/"); // strip "[" "]"
                spans.push({text, role});
                pos = right_pos + 1;
            } else {
                let right_pos = sentence.indexOf("[", pos);
                if (right_pos < 0) {
                    right_pos = sentence.length;
                    const text = sentence.substring(pos, right_pos);
                    spans.push({text, role: undefined});
                } else {
                    const text = sentence.substring(pos, right_pos);
                    spans.push({text, role: undefined});
                }
                pos = right_pos;
            }
        }
        return spans;
    }

    stringRepr() {
        return this.map(span => {
            if (!span.role) {
                return span.text;
            } else {
                return `[${span.text}/${span.role}]`;
            }
        }).join("");
    }

    generalize(frame): Sentence {
        /**
         * [Experiencer][Envy-Pity][Target_Entity] ->
         * [Experiencer][__CURRENT_FRAME__][Target_Entity]
         */
        const ret = this.map(span => {
            const ret: Span = {text: span.text, role: span.role};
            if (ret.role && ret.role.startsWith(frame)) {
                ret.role = ret.role.replace(frame, "__CURRENT_FRAME__");
            }
            return ret;
        });
        Object.setPrototypeOf(ret, Sentence.prototype);
        return ret as Sentence;
    }

    specialize(frame: string): Sentence {
        /**
         * [Experiencer][__CURRENT_FRAME__][Target_Entity] ->
         * [Experiencer][Envy-Pity][Target_Entity]
         */
        const ret = this.map(span => {
            const ret: Span = {text: span.text, role: span.role};
            if (ret.role && ret.role.startsWith("__CURRENT_FRAME__")) {
                ret.role = ret.role.replace("__CURRENT_FRAME__", frame);
            }
            return ret;
        });
        Object.setPrototypeOf(ret, Sentence.prototype);
        return ret as Sentence;
    }
}


export namespace TAGFile {
    export function splitHeader(tagFileContent: string): [string[], Sentence[]] {
        const lines = tagFileContent.split("\n").map(x => x.trim());

        // search boundary
        let i = 0;
        for (; i < lines.length && (lines[i] === "" ||
            lines[i].startsWith("##") ||
            (lines[i].startsWith("%%") &&
                !lines[i].startsWith("%%PATTERN")) &&
            !lines[i].startsWith("%%CONSTRUCTION")); i++) {
        }
        const header: string[] = lines.slice(0, i);
        const sentences: Sentence[] = [];
        lines.slice(i).filter(line => line !== '' && !line.startsWith("%%")).forEach(line => {
            if (line.startsWith("##")) {
                header.push(line);
            } else {
                sentences.push(Sentence.parseSentence(line));
            }
        });
        return [header, sentences];
    }

    export function splitAttrs(tagFileContent: string): [Map<string, string>, Sentence[]] {
        const [header, sentences] = TAGFile.splitHeader(tagFileContent);
        const attrs: Map<string, string> = new Map();
        header.forEach(line => {
            if (line.startsWith("##")) {
                const [name, value] = line.replace("##", "")
                    .trim().split(":", 2);
                if (value !== undefined) {
                    attrs.set(name.trim(), value.trim());
                }
            }
        });
        return [attrs, sentences];
    }
}

export class Verb {
    public name: string;
    public sentences: Sentence[];
    public pinyin: string | undefined;
    public frequency: string | undefined;

    constructor(name, fields) {
        this.name = name;
        Object.assign(this, fields);
    }

    static fromTAGFile(name, content, onErr?: (err: string) => void) {
        const [attrs, sentences] = TAGFile.splitAttrs(content);
        return new Verb(name, {
            sentences, pinyin: attrs.get("pinyin"),
            frequency: attrs.get("frequency")
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/problem-domain/verb.ts